/** Formats Indian phone numbers for search result meta rows. */
export function formatPhoneDisplay(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  return phone;
}

export const INVOICE_STATUS_BADGE: Record<string, 'mint' | 'amber' | 'brand' | 'neutral'> = {
  paid: 'mint',
  issued: 'amber',
  partially_paid: 'brand',
  cancelled: 'neutral',
};

export function invoiceStatusLabel(status: string): string {
  if (status === 'paid') return 'Paid';
  if (status === 'partially_paid') return 'Partial';
  if (status === 'issued') return 'Pending';
  return status;
}

export const APPOINTMENT_STATUS_BADGE: Record<
  string,
  'mint' | 'amber' | 'brand' | 'neutral' | 'coral'
> = {
  scheduled: 'brand',
  confirmed: 'mint',
  checked_in: 'amber',
  in_progress: 'amber',
  completed: 'mint',
  cancelled: 'neutral',
  no_show: 'coral',
};

export function appointmentStatusLabel(status: string): string {
  if (status === 'checked_in') return 'Checked in';
  if (status === 'in_progress') return 'In progress';
  if (status === 'no_show') return 'No-show';
  return status.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

